// Configuration for the staging environment. Angular swaps this file in via the
// fileReplacements entry for each build configuration in angular.json.
import type { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  '137': {
    TRANSH_URL: "https://polygonscan.com/tx/",
    EXPLORER_URL: "https://www.oklink.com/amoy",
    FACTORY_ADDRESS: "0x8e1989b1919fb8F0c0082540CB3343427B16dA61",
    ACCESS_CONTROL_TOKEN: "0x4D46A881B53D7CbaF31fb438f5F77A918c666998",
    PROVIDER: "https://polygon-mainnet.infura.io/v3/23443853a2d64ece8aa57df34dd0a2a2",
    PROVIDERS: [
      "https://polygon-mainnet.g.alchemy.com/v2/alch_JzwQoGfDPpwHHkVjFIruX", // Alchemy Developer Key
      "https://polygon-mainnet.infura.io/v3/23443853a2d64ece8aa57df34dd0a2a2",  // Infura Developer Key
      "https://polygon-bor-rpc.publicnode.com", 
      "https://polygon-rpc.com", 
      "https://polygon.drpc.org"],
    CHAIN_NETWORK: "0x89",
    CHAINID: 137,
    CURRENCY_NAME: "MATIC",
    CURRENCY_SYMBOL: "MATIC",
    CHAIN_NAME: "Polygon",
    FILE_PATH: "",
    BORROW_LEND_CONTRACT: "0x1a82d7EC18D0b7f14fcA66CF348AF89293E2597E",
    EXCHANGE_CONTRACT: "0x27891344D21784069693E95Fba864220846f6468",
    LAZYMINT_CONTRACT: "0x374bC619D7Fd992cA96e9E09c978442ee5c37e2b",
    ERC721_CONTRACT: "0x3b9c6e3124421e26a2a1Fd685921E41E8ad96247",
    PLATFORM_FEE: "0x9b69b1d02528f5073Cbe00e7DE86D42a8F85EC22",
    ONBOARD_CONTRACT: "0xf3662051FC77a8A428F30194d97D64c58D51c308"
  },
  '80002': {
    TRANSH_URL: "https://mumbai.polygonscan.com/tx/",
    EXPLORER_URL: "https://mumbai.polygonscan.com/",
    FACTORY_ADDRESS: "0xf464ea4a4bf6ef44afaf226a9d5a366240fee3ef",
    ACCESS_CONTROL_TOKEN: "0x7Fc41CcB5f94ABE4E56949B3F06042780F7cDDab",
    PROVIDER: "https://rpc-amoy.polygon.technology",
    PROVIDERS: ["https://rpc-amoy.polygon.technology", "https://polygon-amoy-bor-rpc.publicnode.com", "https://polygon-amoy.drpc.org"],
    CHAIN_NETWORK: "0x13882",
    CHAINID: 80002,
    CURRENCY_NAME: "MATIC",
    CURRENCY_SYMBOL: "MATIC",
    CHAIN_NAME: "Polygon Test Network",
    FILE_PATH: "",
    BORROW_LEND_CONTRACT: "0x4D41C7BeF6F96Cc5fB67D010E45d0a8CC3d78bBC",
    EXCHANGE_CONTRACT: "0xBc17a089ff98b896c9F9C0F1058bdA24BF50d95A",
    LAZYMINT_CONTRACT: "0x692D575C4F4753ec9aB7858E27a28092944F2cb0",
    ERC721_CONTRACT: "0x18c9a0EFF3C0394440De38acB1C63ABf6ad5B542",
    PLATFORM_FEE: "0x9b69b1d02528f5073Cbe00e7DE86D42a8F85EC22",
    ONBOARD_CONTRACT: "0xB11Bd85FEd80F8e12cf7d71c54eB2a5469d92D9F"
  },
  production: false,
  BASE_URL: "https://chocolate-magnificent-blackbird-410.mypinata.cloud/ipfs/",
  API_BASE_URL: "https://stagingapi.realworld.fi/api/v1",
  API_BASE_URL_V2: "https://stagingapi.realworld.fi/api/v2",
  API_BASE_URL_V3: "https://stagingapi.realworld.fi/api/v3",
  SUPPORTED_CHAINS: ["137", "80002"],
  CHAIN_ID: "0x13882",
  WEB_SITE_URL: "https://stagingapp.realworld.fi",
  WALLET_CONNECT_PROJECT_ID: "b6c201630414d0fd586cfc6add82cde7",
  MARKETPLACE_URL: "https://stagingmarket.realworld.fi/",
  AUTO_LOGOUT_DURATION: 21600,
  AUTO_LOGOUT_TIMEOUT: 30,
  // Frontend error alerts to the ops Telegram channel, delivered through the backend relay
  // (no bot token or chat id in this file — they stay server-side).
  ENABLE_TELEGRAM_ERROR_ALERTS: true,
  TELEGRAM_TRACK_TOAST_ERRORS: true
} as AppEnvironment;
